module.exports = __webpack_public_path__ + "images/custom-blue-2674effc.svg";